{
  "action": "Action",
  "allSides": "सभी पक्ष",
  "allStatus": "सभी स्थिति",
  "amount": "अमाउंट",
  "assetsWallet": "एसेट्स / वॉलेट",
  "available": "उपलब्ध",
  "availableBalance": "उपलब्ध बैलेंस",
  "baseCurrency": "आधार मुद्रा",
  "buy": "Buy",
  "buyExalt": "EXALT खरीदें",
  "buyLong": "Buy / Long",
  "buySellTabs": "खरीदें या बेचें",
  "buyToken": "कॉइन खरीदें",
  "cancelOrder": "ऑर्डर रद्द करें",
  "cancelOrderFailed": "Order cancel नहीं हो सका",
  "cancelled": "Cancelled",
  "cancelledOrders": "रद्द किए गए ऑर्डर",
  "change24h": "24 घंटे बदलाव",
  "close": "बंद करें",
  "completed": "Completed",
  "confirmCancelOrder": "क्या आप वाकई यह order cancel करना चाहते हैं?",
  "connectWalletFirst": "पहले वॉलेट कनेक्ट करें",
  "cost": "कॉस्ट",
  "deposits": "जमा",
  "done": "पूर्ण",
  "enterAmount": "राशि दर्ज करें",
  "enterPrice": "मूल्य दर्ज करें",
  "enterValidAmount": "कृपया मान्य राशि दर्ज करें।",
  "enterValidPrice": "कृपया मान्य मूल्य दर्ज करें।",
  "exportCsv": "CSV निर्यात करें",
  "failed": "Failed",
  "filled": "Filled",
  "filledOrders": "पूर्ण किए गए ऑर्डर",
  "filtered": "फ़िल्टर किया गया",
  "hash": "हैश",
  "high24h": "24H उच्चतम",
  "installWallet": "कृपया MetaMask या Trust Wallet इंस्टॉल करें",
  "instruments": "इंस्ट्रूमेंट्स",
  "insufficientBalance": "अपर्याप्त बैलेंस।",
  "lastPrice": "अंतिम मूल्य",
  "limit": "लिमिट",
  "limitOrder": "लिमिट ऑर्डर",
  "limitPrice": "लिमिट कीमत",
  "loadingOrders": "Orders load हो रहे हैं...",
  "loadingTrades": "ट्रेड लोड हो रहे हैं...",
  "loadingTransactions": "लेनदेन लोड हो रहे हैं...",
  "low24h": "24H न्यूनतम",
  "manageFutures": "फ्यूचर्स प्रबंधित करें",
  "market": "मार्केट",
  "marketOrder": "मार्केट ऑर्डर",
  "marketOrderNotice": "मार्केट ऑर्डर वर्तमान में उपलब्ध लिक्विडिटी के विरुद्ध तुरंत निष्पादित होते हैं। निष्पादन मूल्य भिन्न हो सकता है, और अपूर्ण भाग खुला नहीं रहेगा - इसे तुरंत रद्द कर दिया जाता है।",
  "marketPrice": "बाज़ार मूल्य",
  "mobileTradingChart": "मोबाइल ट्रेडिंग चार्ट",
  "moreOptions": "मोर ऑप्शन्स",
  "noFilledOrders": "कोई पूर्ण किया गया ऑर्डर नहीं।",
  "noOpenOrders": "कोई खुला ऑर्डर नहीं।",
  "noOrdersFound": "कोई orders नहीं मिले।",
  "noTradeHistory": "कोई ट्रेड इतिहास नहीं मिला।",
  "noTransactionsFound": "कोई लेनदेन नहीं मिला।",
  "officialExaltContract": "Official EXALT Contract",
  "open": "Open",
  "openOrders": "ओपन ऑर्डर्स",
  "orderBook": "ऑर्डर बुक",
  "orderCancelledSuccessfully": "Order successfully cancel हो गया",
  "orderFailed": "ऑर्डर विफल रहा।",
  "orderHistory": "ऑर्डर इतिहास",
  "orderIdMissing": "ऑर्डर ID गुम है।",
  "orderPlacedSuccessfully": "ऑर्डर सफलतापूर्वक दिया गया।",
  "orderType": "ऑर्डर टाइप",
  "pair": "Pair",
  "pending": "Pending",
  "placeOrder": "ऑर्डर दें",
  "placingOrder": "ऑर्डर दिया जा रहा है...",
  "positionHistory": "पोजीशन हिस्ट्री",
  "price": "कीमत",
  "processing": "प्रोसेसिंग...",
  "quoteCurrency": "कोट करेंसी",
  "recentTrades": "हाल के ट्रेड",
  "searchMarket": "मार्केट खोजें...",
  "searchPair": "पेयर खोजें...",
  "searchPairSideStatus": "जोड़ी, पक्ष या स्थिति खोजें...",
  "searchTransactions": "लेनदेन खोजें...",
  "selectPair": "जोड़ी चुनें",
  "sell": "Sell",
  "sellExalt": "EXALT बेचें",
  "sellShort": "Sell / Short",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "side": "Side",
  "slPrice": "SL कीमत",
  "spotMarkets": "स्पॉट मार्केट्स",
  "spotTrading": "स्पॉट ट्रेडिंग",
  "spotTradingSubtitle": "Exalt Exchange द्वारा संचालित पेशेवर स्पॉट ट्रेडिंग इंजन",
  "status": "स्टेटस",
  "stopLoss": "स्टॉप लॉस",
  "swapToExalt": "EXALT में Swap करें",
  "takeProfit": "टेक प्रॉफिट",
  "token": "टोकन",
  "total": "Total",
  "tpPrice": "TP कीमत",
  "tpSl": "TP/SL",
  "tradFi": "ट्रेडफाई / सीएफडी",
  "tradFiNoProvider": "अभी तक कोई सीएफडी/ट्रेडफाई लिक्विडिटी प्रदाता कनेक्ट नहीं है।",
  "tradFiNoProviderDescription": "यह मॉड्यूल प्रदाता-तैयार स्टेजिंग आर्किटेक्चर है। एक वास्तविक ब्रोकर/लिक्विडिटी प्रदाता कनेक्ट और सत्यापित होने पर यहां फॉरेक्स, मेटल्स, इंडेक्स, स्टॉक्स और क्रिप्टो सीएफडी इंस्ट्रूमेंट दिखाई देंगे।",
  "tradFiStatusUnavailable": "अभी ट्रेडफाई प्रदाता की स्थिति लोड नहीं हो सकी।",
  "tradeHistory": "ट्रेड हिस्ट्री",
  "trades": "ट्रेड",
  "tradingViewChart": "TradingView चार्ट",
  "transactionHistory": "ट्रांजैक्शन इतिहास",
  "volume24h": "24 घंटे वॉल्यूम",
  "walletConnected": "वॉलेट सफलतापूर्वक कनेक्ट हो गया",
  "walletConnectionFailed": "वॉलेट कनेक्ट नहीं हो सका",
  "withdrawal": "निकासी",
  "withdrawals": "निकासी"
}